import { RootState } from '@/store/store'

export const selectInlineEditSelection = (state: RootState, props: { conversationId: string }) =>
  state.inlineEditState.sessions[props.conversationId]?.selection ?? null

export const selectInlineEditIsSubmitting = (state: RootState, props: { conversationId: string }) =>
  state.inlineEditState.sessions[props.conversationId]?.isSubmitting ?? false

export const selectInlineEditPendingReplacement = (state: RootState, props: { conversationId: string }) =>
  state.inlineEditState.sessions[props.conversationId]?.pendingReplacement ?? null
